const config = {
  siteName: process.env.SITE_NAME || "Gia Phả OS",
  exampleEmail: process.env.EXAMPLE_EMAIL || "",
  examplePassword: process.env.EXAMPLE_PASSWORD || "",
  demoDomain: process.env.DEMO_DOMAIN || "giapha-os.homielab.com",
};

export default config;
